import { MediaQueryStyleSheet } from 'react-native-responsive';
import { PALETTE } from '../../../constants';

export default MediaQueryStyleSheet.create({
  mainWrapper: {
    flex: 1,
  },
  content: {
    display: 'block', 
    paddingHorizontal: 40,
    paddingBottom: 40,
  },
  inputFields: {
    flex: 1,
  },
  label: {
    paddingTop: 10,
  },
  resetCode: {
    minHeight: 50,
  },
  submitButton: {
    marginTop: 100,
  },
  submitButtonDisabled: {
    marginTop: 100,
    backgroundColor: PALETTE.primaryTextDisabled,
  },
  forgotPasswordPrompt: {
    flex: 1,
  },
  wrongUserPassword: {
    display: 'block'
  },
  attemptCount: {
    flex: 1,
    flexDirection: 'column',
    alignItems: 'center',
    paddingTop: 30,
  },
  errorTextColor: {
    color: 'red',
  },
});
